import { render } from "./AcceptApplicantSetupSalary.vue?vue&type=template&id=591c6210"
import script from "./AcceptApplicantSetupSalary.vue?vue&type=script&lang=js"
export * from "./AcceptApplicantSetupSalary.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__